import { IconProps } from "./Icons";

export const IconAmbulance = ({
  width = 70,
  height = 70,
  isHovered = false,
  ...props
}: IconProps) => {
  if (isHovered) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 38 27"
        {...props}
      >
        <path
          fill="#fff"
          d="M10.415 10.664a1.25 1.25 0 0 1 1.25-1.25h2.5v-2.5a1.25 1.25 0 1 1 2.5 0v2.5h2.5a1.25 1.25 0 1 1 0 2.5h-2.5v2.5a1.25 1.25 0 0 1-2.5 0v-2.5h-2.5a1.25 1.25 0 0 1-1.25-1.25Zm27.5 0v10a2.5 2.5 0 0 1-2.5 2.5h-2.656a5 5 0 0 1-9.688 0H15.26a5 5 0 0 1-9.688 0H2.915a2.5 2.5 0 0 1-2.5-2.5v-17.5a2.5 2.5 0 0 1 2.5-2.5h23.75a1.25 1.25 0 0 1 1.25 1.25v1.25h5.403a2.49 2.49 0 0 1 2.322 1.572l2.188 5.469c.058.146.087.302.087.46Zm-10-5v3.75h6.903l-1.5-3.75h-5.403Zm-25 15h2.656a5 5 0 0 1 9.688 0h7.812a5.018 5.018 0 0 1 2.344-3.077V3.164h-22.5v17.5Zm10 1.25a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm17.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm5-1.25v-8.75h-7.5v5a5.01 5.01 0 0 1 4.844 3.75h2.656Z"
        />
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 38 27"
      {...props}
    >
      <path
        fill="#fff"
        d="M37.775 10.75v10a2.5 2.5 0 0 1-2.5 2.5H32.62a5 5 0 0 1-9.687 0h-7.813a5 5 0 0 1-9.687 0H2.775a2.5 2.5 0 0 1-2.5-2.5V3.25a2.5 2.5 0 0 1 2.5-2.5h23.75A1.25 1.25 0 0 1 27.775 2v1.25h5.404A2.489 2.489 0 0 1 35.5 4.822l2.188 5.469c.058.146.088.302.087.459Zm-10-5V9.5h6.904l-1.5-3.75h-5.404Zm-25 15h2.657a5 5 0 0 1 9.687 0h7.813a5.018 5.018 0 0 1 2.343-3.077V3.25h-22.5v17.5Zm10 1.25a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm17.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm5-1.25V12h-7.5v5a5.01 5.01 0 0 1 4.844 3.75h2.656Z"
      />
    </svg>
  );
};
